import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-program-information-badge',
  templateUrl: './program-information-badge.component.html',
  styleUrls: ['./program-information-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgramInformationBadgeComponent {}
